import { render, staticRenderFns } from "./BrandMediaDefaultLayout.vue?vue&type=template&id=7744aced&scoped=true&"
import script from "./BrandMediaDefaultLayout.vue?vue&type=script&lang=ts&"
export * from "./BrandMediaDefaultLayout.vue?vue&type=script&lang=ts&"
import style0 from "./BrandMediaDefaultLayout.vue?vue&type=style&index=0&id=7744aced&prod&lang=scss&"
import style1 from "./BrandMediaDefaultLayout.vue?vue&type=style&index=1&id=7744aced&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7744aced",
  null
  
)

export default component.exports